import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
const principles = [{
  title: 'Research-led',
  text: 'Every recommendation is grounded in a mapped, understood market.'
}, {
  title: 'Discreet',
  text: 'Confidentiality protects clients and candidates at every stage.'
}, {
  title: 'Relationship-driven',
  text: 'We measure success by appointments that endure.'
}];
export function IntroSection() {
  return <section className="bg-ivory py-24 md:py-32" data-id="element-223" data-mp="zzifu6awlc4j">
      <div className="container-page grid gap-14 lg:grid-cols-12" data-id="element-224" data-mp="100abti8exbvc">
        <Reveal className="lg:col-span-7" data-id="element-225" data-mp="14y3hma5t03v3">
          <h2 className="font-display text-4xl font-semibold leading-[1.12] text-ink md:text-[52px]" data-id="element-226" data-mp="1517qvly4lpsm">
            A considered partner for the appointments that matter most to your organisation.
          </h2>
        </Reveal>
        <Reveal className="lg:col-span-5" delay={0.05} data-id="element-227" data-mp="2ld4szqpkui0l">
          <p className="text-lg leading-relaxed text-muted" data-id="element-228" data-mp="2lbjx9xrj0t15">
            Corventa Talent Search works with boards, chief executives and leadership teams to identify, assess and appoint people who shape
            performance. We combine the rigour of executive search with a genuinely personal approach for every candidate we meet.
          </p>
          <dl className="mt-8 divide-y divide-line border-y border-line" data-id="element-229" data-mp="11g3uev8179yx">
            {principles.map(p => <div key={p.title} className="grid grid-cols-[140px_1fr] gap-4 py-4" data-id="element-230" data-mp="wgr6061ihuu8">
                <dt className="font-medium text-ink" data-id="element-231" data-mp="rp97rpqvi8cy">{p.title}</dt>
                <dd className="text-muted" data-id="element-232" data-mp="rny3lotimylb">{p.text}</dd>
              </div>)}
          </dl>
          <Link to="/about" className="mt-7 inline-flex items-center gap-2 font-medium text-royal hover:text-midnight" data-id="element-233" data-mp="mobotay1haae">
            About Corventa
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-234" data-mp="doydsdu9odnk" />
          </Link>
        </Reveal>
      </div>
    </section>;
}